export default __webpack_public_path__ + "static/media/SEC1460.34I-32571_-26078_0.97f3822a.jpg";